export default __webpack_public_path__ + "static/media/ageur.8c7c01d6.webp";